<template>
  <div>
    <my-table :title="title"
              :searchParams="searchParams"
              :isAdd="isAdd"
              :tableData="tableData"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()" @add="addVideo">
      <div slot="table">
        <video-table :tableData="tableData.list" @view="view" @update="update" @del="del"></video-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import videoTable from "./VideoTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {delByVideoId, getVideoBySearch, newVue} from "../../network/video";

  export default {
    name: "VideoList",
    components: {videoTable, MyTable},
    data(){
      return {
        title: "微视频列表",
        //搜索条件
        searchParams:[
          {
            key:"title",
            value:"视频名称"
          },
          {
            key:"merchantsName",
            value:"所属农基商"
          },
          {
            key:"videoClassify",
            value:"视频分类"
          }
        ],
        isAdd: true,
        tableData:{},
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/video/list";
      this.common.HeaderLocationTwo.name =  "微视频管理"
      this.common.HeaderLocationThree.name = "微视频列表"
      getVideoBySearch().then(res => {
        this.tableData = res.data;
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let title = null;
        let merchantsName = null;
        let videoClassify = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "title"){
            title = searchItems[i].input
          }else if (searchItems[i].value === "merchantsName"){
            merchantsName = searchItems[i].input
          }else if (searchItems[i].value === "videoClassify") {
            videoClassify = searchItems[i].input
          }
        }
        getVideoBySearch(title,merchantsName,videoClassify,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      view(id){
        this.$router.push("data/"+id)
      },
      update(id){
        this.$router.push("insert/"+id)
      },
      del(id){
        this.$confirm('此操作将永久删除该视频, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delByVideoId(id).then(res => {
              this.searchEasy(this.searchItems);
            }
          )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      addVideo(){
        this.$router.push("insert/")
      }
    }
  }
</script>

<style scoped>

</style>
